<template>
  <div class="container">
    <van-nav-bar title="充电详情" left-text="" 
      left-arrow @click-left="onClickLeft">
    </van-nav-bar>

    <div class="list-box">
      <div class="list">订单编号：{{objDetail.id}}</div>
      <div class="list">订单时间：{{objDetail.createTime}}</div>
      <div class="list">订单状态：{{objDetail.statusDesc}} <span v-if="objDetail.status==30" @click="onStop" class="stop">关闭</span></div>
      <div class="list">所属项目：{{objDetail.fullCommunityName}}</div>
      <div class="list">
        <span class="width200">设备编号：{{objDetail.mainNo}}</span>
        <span class="">插座编号：{{objDetail.loopNo}}</span>
      </div>
      <div class="list">
        用户手机：
        <a :href="'tel:'+objDetail.mobile">
          {{objDetail.mobile}}
          <van-icon class="tel" name="phone-o" />
        </a>
      </div>
      <div class="list">
        <span class="width200">实付金额：{{objDetail.amount}}元</span>
        <span class="">预付金额：{{objDetail.preAmount}}元</span>
      </div>
      <div class="list2" v-if="objDetail.insuredAmount>0&&userInfo.type == 1">安心充电金额：{{objDetail.insuredAmount}}</div>
      <div class="list2">充电时长：{{objDetail.time}}</div>
      <div class="list2">退款金额：{{objDetail.refundAmount}}元</div>
      <div class="list2">用电度数：{{objDetail.degrees}}度</div>
      <div class="list">收费标准：{{objDetail.priceDesc}}</div>
      <div class="list">开始时间：{{objDetail.startTime}}</div>
      <div class="list">结束时间：{{objDetail.endTime}}</div>
      <div class="list">电车功率：{{objDetail.p}}W</div>
      <div class="list">计费公式：{{objDetail.billCalculate}}</div>
      <div class="list">结束原因：{{objDetail.overTypeDesc}}</div>
      <div class="list">功率曲线：</div>
    </div>
    <div class="echart_panel">
      <div id="pieEchart1" style="width:100%;height:240px;"></div>
    </div>
    <van-divider />
    <div class="title">订单生命周期</div>

    <div class="box">
      <van-steps direction="vertical" :active="flowsList.length-1" active-color="#7BC9FF" inactive-color='#7BC9FF'>
        <van-step :key="index" v-for="(item,index) in flowsList">
          <div class="time">{{item.createTime}}</div>
          <div class="msg">{{item.message}}</div>
        </van-step>
      </van-steps>
    </div>
    

  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Image,Toast,Loading,Step, Steps,Divider } from 'vant';
  export default {
    data() {
      return {
        objDetail: {},
        flowsList:[],
        xDataList:[],
        yDataList:[],
        userInfo:{}
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Step.name]:Step,
      [Steps.name]:Steps, 
      [Divider.name]:Divider, 
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html"})
      },
      changeTab(){
        this.finished = false;
        this.pageSize = 5;
      },
      getDetail(){
        let url = this.$route.query.history?"/charge/hisget?id=":"/charge/get?id="
        axios.get(url+this.$route.query.orderId,{
        }).then((res)=>{
          this.objDetail = res.data;
          if(res.data.status == 30){
            //充电中
            this.objDetail.time = '';
          }else{
            var h = 0,m = 0;
            h = parseInt(this.objDetail.minutes / 60);
            m = parseInt(this.objDetail.minutes % 60);
            if(h>0){
              this.objDetail.time = h+'小时'+m+'分钟'
            }else{
              this.objDetail.time = m+'分钟'
            }
          }
          
        })

        let getflows = this.$route.query.history?"/charge/hisgetflows?chargeOrderId=":"/charge/getflows?chargeOrderId="
        axios.get(getflows+this.$route.query.orderId,{
        }).then((res)=>{
          this.flowsList = res.data;
        })
      },
      getPowers(){
        let getpowers = this.$route.query.history?"/charge/hisgetpowers?chargeOrderId=":"/charge/getpowers?chargeOrderId="
        axios.get(getpowers+this.$route.query.orderId,{
        }).then((res)=>{
          if(res.data.length > 0){
            res.data.forEach(item=>{
              this.xDataList.push(item.uploadTime.split(' ')[1])
              this.yDataList.push(item.p)
            })
            this.initLineeChart();
          }
          Toast.clear();
        })
      },
      getUserInfo() {
        axios.get("/auth/getuserinfo",{
        }).then((res)=>{
          this.userInfo = res.data;
        })
      },
      initLineeChart() {
        let myChart = this.$echarts.init(document.getElementById('pieEchart1'));
        myChart.setOption({
          grid: {
            left: 35,
            top: 30,
            bottom: 60,
            right: 20
          },
          tooltip: {
            trigger: 'axis',
          },
          legend: {
            show: true,
            data: [],
            right: 20,
            top: 20,
            itemWidth: 12,
            itemHeight: 8,
            itemGap: 20,
            borderRadius: 0,
            textStyle: {
              color: "#fff",
              fontSize: 11,
            },
          },
          xAxis: [
            {
              type: "category",
              data: this.xDataList,
              axisLabel: {
                textStyle: {
                  color: '#999',
                  fontSize: 12
                }
              },
              axisTick: {
                show: false, // 是否显示坐标轴轴线
                lineStyle: {
                  color: "#C1C7D0",
                },
              },
              splitLine: {
                show: false,
              },
              boundaryGap: true,
              axisLine: {
                //坐标轴轴线相关设置。
                show: true,
                inside: false,
                lineStyle: {
                  color: "#C1C7D0",
                },
              },
            },
          ],
          yAxis: [
            {
              name: '单位(瓦)',
              nameTextStyle:{
                color:"#999", 
                fontSize: 12,  
                padding: [20, 0, -10, 40]
              },
              type: "value",
              min: 0,
              splitNumber: 4,
              axisLabel: {
                //坐标轴刻度标签的相关设置。
                show: true,
                textStyle: {
                  color: '#999',
                  fontSize: 12
                }
              },
              axisTick: {
                show: true, // 是否显示坐标轴轴线
                lineStyle: {
                  color: "#C1C7D0",
                },
              },
              axisLine: {
                //坐标轴轴线相关设置。
                show: true,
                lineStyle: {
                  color: "#C1C7D0",
                },
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#C1C7D0",
                },
              },
            },
          ],
          //横坐标控制器
          dataZoom: [{
              startValue: 0
          }, {
              type: 'slider'
          }],
          series: [
            {
              type: "line",
              name: '功率',
              barMaxWidth: 12,
              zlevel: 10,
              data: this.yDataList,
              smooth: true,//平滑折现
              itemStyle: {
                normal: {
                  color: "#2479E5",
                },
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1.5, [
                  {
                    offset: 0,
                    color: "#2479E5",
                  },
                  {
                    offset: 1,
                    color: "transparent",
                  },
                ]),
              },
            },
          ],
        });
      },
      onClickLeft() {      
        sessionStorage.setItem('chargeDetailBack', true);
        this.$router.back();
      },
      onClickRight() {
        
      },
      onStop() {
        Toast.loading({
          duration: 0,       // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: 'spinner',
          message: '关闭中...'
        });
        axios.post("/charge/stop", {
          chargeOrderId: this.$route.query.orderId
        }).then((res) => {
          Toast.clear();
          if(res.isSuccess){
            this.getDetail();
          }
        })
      },
    },
    computed:{
    },
    created () {
      Toast.loading({
        duration: 0,       // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '数据加载中...'
      });
      this.getUserInfo();
      this.getDetail();
      this.getPowers();
    },
    mounted () {
      
    },
    destroyed () {}
  }
</script>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #fff}
  .container{
    width: 100%;min-height: 100vh;letter-spacing:0px;background: #fff;
  }
  .list-box{
    width: 100%;
    color: #373737;
    padding: 12px 20px 0 20px;
    .list{
      font-size: 14px;
      width: 100%;
      margin-bottom: 10px;
      .width200{width: 230px; display: inline-block;}
    }
    .list2{
      font-size: 14px;
      width: 50%;
      margin-bottom: 10px;
      display: inline-block;
    }
  }
  .tel{
    font-size: 20px;
    vertical-align: top;
    margin-left: 15px;
  }
  .stop{
    color: #0000EE;
    border: 1px solid #0000EE;
    border-radius: 10px;
    padding: 0 5px;
    margin-left: 10px;
  }
  .title{
    font-size: 14px;
    font-weight: bold;
    text-align: left;
    color: #373737;
    padding: 0 0 10px 20px;
  }

  .box{
    padding: 0 10px;
    font-size: 14px;
    .time{
      color: #999999;
      margin-bottom: 8px;
    }
    .msg{color: #373737;}
  }

  .echart_panel{
    width: 100%;
    height: 200px;
    margin-bottom: 50px;
  }
  
</style>
